import { Injectable } from '@angular/core';
import {
  addDoc,
  collection,
  doc,
  Firestore,
  getDocs,
  increment,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from '@angular/fire/firestore';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private firestore: Firestore) {}

  /** ✅ Create Razorpay order */
  createOrder(amount: number, credits: number): Observable<any> {
    const functions = getFunctions();
    const createOrderCallable = httpsCallable(functions, 'createOrder');

    return from(createOrderCallable({ amount, credits }));
  }
  // createOrder(amount: number, currency: string = 'INR'): Observable<any> {
  //   const functions = getFunctions();
  //   const createOrderCallable = httpsCallable(functions, 'createOrder');

  //   return from(createOrderCallable({ amount, currency }));
  // }

  verifyPayment(razorpayResponse: any): Observable<any> {
    const functions = getFunctions();

    const verifyFn = httpsCallable(functions, 'verifyPayment');
    return from(
      verifyFn({
        razorpay_order_id: razorpayResponse.razorpay_order_id,
        razorpay_payment_id: razorpayResponse.razorpay_payment_id,
        razorpay_signature: razorpayResponse.razorpay_signature,
      }),
    );
  }

  /** ✅ Get payment status */
  getPaymentStatus(razorpayOrderId: string): Observable<any> {
    const functions = getFunctions();
    const getPaymentStatusCallable = httpsCallable(
      functions,
      'getPaymentStatus',
    );

    return from(getPaymentStatusCallable({ razorpayOrderId }));
  }

  /** Create placeholder payment doc */
  async createPaymentDoc(
    uid: string,
    orderId: string,
    amount: number,
    currency: string,
  ) {
    console.log('Creating payment doc for orderId:', orderId, uid);
    const colRef = collection(this.firestore, 'payments');
    const docRef = await addDoc(colRef, {
      uid,
      orderId,
      amount,
      currency,
      status: 'initiated',
      createdOn: serverTimestamp(),
    });
    return docRef.id; // Firestore doc id
  }

  /** Update doc after success */
  async updatePaymentSuccess(
    docId: string,
    razorpayResponse: any,
    uid: string,
  ) {
    const docRef = doc(this.firestore, 'payments', docId);
    await updateDoc(docRef, {
      status: 'success',
      razorpayResponse,
      updatedOn: serverTimestamp(),
    });

    // 🔑 increment credits for user
    const userRef = doc(this.firestore, 'users', uid);
    await updateDoc(userRef, {
      credits: increment(100),
      updatedAt: serverTimestamp(),
    });
  }

  /** Update doc after failure */
  async updatePaymentFailure(docId: string, razorpayResponse: any) {
    const docRef = doc(this.firestore, 'payments', docId);
    await updateDoc(docRef, {
      status: 'failed',
      razorpayResponse,
      updatedOn: serverTimestamp(),
    });
  }

  /** Fetch user's payments ordered by createdOn desc */
  async getUserPayments(uid: string) {
    const colRef = collection(this.firestore, 'payments');
    const q = query(
      colRef,
      where('uid', '==', uid),
      orderBy('createdOn', 'desc'),
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  }
}
